export enum Translations {
  Yes = 'yes',
  No = 'no',
  Download = 'download',
  Share = 'share',
  Search = 'search',
  Filter = 'filter',
  MoreInfo = 'more.info',
  Close = 'close',
  End = 'end',
  Previous = 'previous',
  Next = 'next',

  MenuAlt = 'menu.alt',
  MenuHome = 'menu.home',
  MenuCompanies = 'menu.companies',
  MenuSector = 'menu.sector',
  MenuActivity = 'menu.activity',
  MenuCompanySize = 'menu.companySize',
  MenuLocation = 'menu.location',
  MenuEmployees = 'menu.employees',
  MenuSex = 'menu.sex',
  MenuWomen = 'menu.women',
  MenuAge = 'menu.age',
  MenuJob = 'menu.job',
  MenuJobEvolution = 'menu.jobEvolution',
  MenuInternship = 'menu.internship',
  MenuEvolution = 'menu.evolution',
  MenuTheme = 'menu.theme',
  MenuSelfEmployed = 'menu.selfEmployed',
  MenuKeyFigures = 'menu.keyFigures',
  MenuWorkStudy = 'menu.workStudy',
  MenuApprenticeship = 'menu.apprenticeShip',
  MenuDegree = 'menu.degree',
  MenuDomain = 'menu.domain',
  MenuPro = 'menu.pro',
  MenuStudent = 'menu.student',
  MenuSpecialization = 'menu.specialization',
  CardCompany = 'card.company',
  CardEmployee = 'card.employee',
  CardInternship = 'card.internship',
  CardSelfEmployed = 'card.selfEmployed',
  CardPro = 'card.pro',
  CardApprentice = 'card.apprentice',
  CardStudent = 'card.student',

  HomeCompanies = 'home.companies',
  HomeEmployees = 'home.employees',
  HomeInternship = 'home.internship',
  HomeSelfEmployed = 'home.selfEmployed',
  HomeWorkStudy = 'home.workStudy',
  HomeStudent = 'home.student',
  HomeWebsite = 'home.website',
  HomeWebsiteLink = 'home.websiteLink',
  HomeSituation = 'home.situation',
  HomeSituationLink = 'home.situationLink',
  HomeNewsletter = 'home.newsletter',
  HomeNewsletterLink = 'home.newsletterLink',
  HomeContact = 'home.contact',
  HomeContactLink = 'home.contactLink',
  HomeLegal = 'home.legal',
  HomeTour = 'home.tour',

  ErrorNetwork = 'error.network',

  DataCountry = 'data.country',
  DataRaw = 'data.raw',
  DataComparison = 'data.comparison',
  DataExportPending = 'data.exportPending',
  DataExportError = 'data.exportError',
  DataExportSuccess = 'data.exportSuccess',

  TourTitle = 'tour.title',
  TourContent = 'tour.content',
  TourStepThemeTitle = 'tour.stepThemeTitle',
  TourStepTheme = 'tour.stepTheme',
  TourStepSubThemeTitle = 'tour.stepSubThemeTitle',
  TourStepSubTheme = 'tour.stepSubTheme',
  TourFilterTitle = 'tour.filterTitle',
  TourFilterDesktop = 'tour.filterDesktop',
  TourFilterMobile1 = 'tour.filterMobile1',
  TourFilterMobile2 = 'tour.filterMobile2',
  TourMoreActionsTitle = 'tour.moreActionsTitle',
  TourMoreActions = 'tour.moreActions',

  CompareTitle = 'compare.title',
  CompareRemove = 'compare.remove',
  Compare = 'compare',
  CompareActive = 'compare.active',
  CompareCancel = 'compare.cancel',

  InfoTitle = 'info.title',
  InfoSource = 'info.source',
  InfoTreatments = 'info.treatments',
  InfoYears = 'info.years',

  InfoCompanySource = 'info.company.source',
  InfoCompanyYears = 'info.company.years',
  InfoCompanyTreatments = 'info.company.treatments',
  InfoCompanySector = 'info.company.sectorContent',
  InfoCompanySize = 'info.company.sizeContent',
  InfoCompanyActivity = 'info.company.activityContent',
  InfoCompanyLocation = 'info.company.locationContent',

  InfoEmployeeTotalSource = 'info.employeeTotal.source',
  InfoEmployeeTotalYears = 'info.employeeTotal.years',
  InfoEmployeeTotalTreatments = 'info.employeeTotal.treatments',
  InfoEmployeeWomenTreatments = 'info.employeeWomen.treatments',
  InfoEmployeeWomenSource = 'info.employeeWomen.source',
  InfoEmployeeWomenYears = 'info.employeeWomen.years',
  InfoEmployeeWomen = 'info.employeeWomen.content',
  InfoEmployeeSource = 'info.employee.source',
  InfoEmployeeYears = 'info.employee.years',
  InfoEmployeeAge = 'info.employee.ageContent',
  InfoEmployeeSex = 'info.employee.sexContent',
  InfoEmployeeJob = 'info.employee.jobContent',
  InfoEmployeeJobEvolution = 'info.employee.jobEvolutionContent',
  InfoEmployeeActivity = 'info.employee.activityContent',
  InfoEmployeeTreatments = 'info.employee.treatments',
  InfoEmployeeLocation = 'info.employee.locationContent',

  InfoInternshipSource = 'info.internship.source',
  InfoInternshipYears = 'info.internship.years',
  InfoInternshipTreatments = 'info.internship.treatments',
  InfoInternshipEvolution = 'info.internship.evolutionContent',
  InfoInternshipTheme = 'info.internship.themeContent',

  InfoSelfEmployedSource = 'info.selfEmployed.source',
  InfoSelfEmployedYears = 'info.selfEmployed.years',
  InfoSelfEmployedTreatments = 'info.selfEmployed.treatments',
  InfoSelfEmployedTheme = 'info.selfEmployed.themeContent',
  InfoSelfEmployedKeyFigures = 'info.selfEmployed.keyFiguresContent',

  InfoApprenticeShipSource = 'info.apprenticeship.source',
  InfoApprenticeShipYears = 'info.apprenticeship.years',
  InfoApprenticeShipTreatments = 'info.apprenticeship.treatments',
  InfoApprenticeShipEvolution = 'info.apprenticeship.evolutionContent',
  InfoApprenticeShipDegree = 'info.apprenticeship.degreeContent',
  InfoApprenticeShipDomain = 'info.apprenticeship.domainContent',
  InfoApprenticeShipActivity = 'info.apprenticeship.activityContent',
  InfoApprenticeShipAge = 'info.apprenticeship.ageContent',
  InfoProSource = 'info.pro.source',
  InfoProYears = 'info.pro.years',
  InfoProTreatments = 'info.pro.treatments',
  InfoProEvolution = 'info.pro.evolutionContent',
  InfoProDomain = 'info.pro.domainContent',
  InfoProActivity = 'info.pro.activityContent',
  InfoProAge = 'info.pro.ageContent',

  InfoStudentSource = 'info.student.source',
  InfoStudentYears = 'info.student.years',
  InfoStudentTreatments = 'info.student.treatments',
  InfoStudent = 'info.student.content',

  ShareTitle = 'share.title',
  ShareData = 'share.data',
  ShareCharts = 'share.charts',
  ShareFilters = 'share.filters',
  ShareExcel = 'share.excel',
  ShareCsv = 'share.csv',

  FilterNA = 'filter.na',
  FilterClear = 'filter.clear',
  FilterActive = 'filter.active',
  FilterNoResult = 'filter.noResult',
  FilterJob = 'filter.job',
  FilterLevel = 'filter.level',
  FilterAge = 'filter.age',
  FilterJobGroup = 'filter.jobGroup',
  FilterSubTheme = 'filter.subTheme',
  FilterTheme = 'filter.theme',
  FilterCompanySize = 'filter.companySize',
  FilterYear = 'filter.year',
  FilterActivity = 'filter.activity',
  FilterSector = 'filter.sector',
  FilterRegion = 'filter.region',
  FilterDepartment = 'filter.department',

  CompaniesTitle = 'companies.title',
  CompaniesCount = 'companies.count',
  CompaniesActivityTitle = 'companies.activityTitle',
  CompaniesLocationTitle = 'companies.locationTitle',
  CompaniesSectorTitle = 'companies.sectorTitle',
  CompaniesSizeTitle = 'companies.companySizeTitle',

  EmployeesTitle = 'employees.title',
  EmployeesCount = 'employees.count',
  EmployeesMan = 'employees.man',
  EmployeesWoman = 'employees.woman',
  EmployeesActivityTitle = 'employees.activityTitle',
  EmployeesAgeTitle = 'employees.ageTitle',
  EmployeesJobEvolutionTitle = 'employees.jobEvolutionTitle',
  EmployeesJobTitle = 'employees.jobTitle',
  EmployeesEvolutionWomenTitle = 'employees.evolutionWomenTitle',
  EmployeesGenderTitle = 'employees.genderTitle',
  EmployeesLocationTitle = 'employees.locationTitle',

  InternshipTitle = 'internship.title',
  InternshipCount = 'internship.count',
  InternshipCategoryTitle = 'internship.categoryTitle',
  InternshipEvolutionTitle = 'internship.evolutionTitle',

  SelfEmployedTitle = 'selfEmployed.title',
  SelfEmployedCount = 'selfEmployed.count',
  SelfEmployedKeyFiguresTitle = 'selfEmployed.keyFiguresTitle',
  SelfEmployedThemeTitle = 'selfEmployed.themeTitle',

  StudentTitle = 'student.title',
  StudentCount = 'student.count',
  StudentSpecialityTitle = 'student.specialityTitle',

  WorkStudyTitle = 'workStudy.title',
  WorkStudyApprenticeCount = 'workStudy.apprenticeCount',
  WorkStudyProCount = 'workStudy.proCount',
  WorkStudyApprenticeActivityTitle = 'workStudy.apprenticeActivityTitle',
  WorkStudyApprenticeDegreeTitle = 'workStudy.apprenticeDegreeTitle',
  WorkStudyApprenticeAgeTitle = 'workStudy.apprenticeAgeTitle',
  WorkStudyApprenticeEvolutionTitle = 'workStudy.apprenticeEvolutionTitle',
  WorkStudyApprenticeSectorTitle = 'workStudy.apprenticeSectorTitle',
  WorkStudyProActivityTitle = 'workStudy.proActivityTitle',
  WorkStudyProAgeTitle = 'workStudy.proAgeTitle',
  WorkStudyProEvolutionTitle = 'workStudy.proEvolutionTitle',
  WorkStudyProSectorTitle = 'workStudy.proSectorTitle',
}
